var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"lg":4,"offset-lg":4,"md":4,"offset-md":4}},[_c('vue-form-generator',{ref:"entityInformationForm",attrs:{"schema":_vm.schema,"model":_vm.form,"options":_vm.formOptions}}),_vm._v(" "),_c('new-entity')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cadd0a3e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/new_deal/components/entities/EntitySection.vue
// module id = null
// module chunks = 